import { Injectable } from '@angular/core';
import { AgCellLocalStoreService, AgCellState } from '../../../../global/gx-ag-grid/ag-cell-local-store.service';
import { Observable, switchMap } from 'rxjs';
import { LSCField } from '../../../../../models/LSCFields';
import { selectIsLocationFieldBlacklisted } from '../../state/location-list-selectors';
import { Store } from '@ngrx/store';
import { LocationListLocalStoreService } from '../../location-list-local-store.service';
import { map } from 'rxjs/operators';
import { Location } from '../../../../../models/locations-models/location';

interface BusinessHoursCellState extends AgCellState {
}

@Injectable()
export class BusinessHoursCellLocalStoreService extends AgCellLocalStoreService<BusinessHoursCellState>{
  constructor(private store: Store, private locationListLocalStore: LocationListLocalStoreService) {
    super({
      cellValue: null,
      params: null,
    })
  }

  readonly viewModel$: Observable<{ location: Location, isFieldBlacklisted: boolean, loading: boolean}> =
      this.select({
        location: this.select(this.params$, params => params.data),
        isFieldBlacklisted: this.params$.pipe(
          switchMap((params) =>
              this.store.select(selectIsLocationFieldBlacklisted(
                  params.data?.id,
                  (params.colDef?.field) as LSCField)
              ))),
        loading: this.params$.pipe(
            switchMap((params) =>
                    this.locationListLocalStore.loadingValues$.pipe(
                        map(loadingValues =>
                            loadingValues[params?.data?.id]?.[params?.colDef?.field])
                ))),


  })



}


